import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"

import MetaTags from "react-meta-tags"

import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import { getData, options } from "./data"
import { FiltersCard } from "components/Common/FiltersCard"
import GamesTicketsTable from "./Table"
import {API_URL, sitename} from "../../../constants/constants"
import axios from "axios"
import moment from "moment";
import {Filter} from "./Filter";
const GamesTickets = props => {
  const [item, setItem] = useState("All")
  const [gameTicketsData, setGameTicketsData] = useState([])
  const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"))
  const [fromDate, setFromDate] = useState(moment().format("YYYY-MM-DD"))
  const [type, setType] = useState("Pragmatic")
  const [loadingMessage, setLoadingMessage] = useState("1");
  useEffect(() => {
    call()
  }, [])

  const call = () => {
    setLoadingMessage("1");
    axios({
      method: "get",
      url: `${API_URL}/admin/reports/game-tickets?to=${toDate}&from=${fromDate}&type=${item}&item=${type}`,
    })
      .then(function (response) {
        setGameTicketsData(response?.data?.data)
        setLoadingMessage("0");
      })
      .catch(function (response) {
      })
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Admin" breadcrumbItem="Games Tickets" />
        </Container>
        <Filter
          item={item}
          setItem={setItem}
          options={options}
          toDate={toDate}
          fromDate={fromDate}
          setToDate={d => setToDate(d)}
          setFromDate={d => setFromDate(d)}
          setType={setType}
          type={type}
          call={() => {
            call()
          }}
        />
        <GamesTicketsTable
            data={gameTicketsData}
            type={type}
            loadingMessage={loadingMessage}
            setLoadingMessage={setLoadingMessage}

        />
      </div>
    </React.Fragment>
  )
}

export default withRouter(GamesTickets)
